import { AxiosResponse } from 'axios'

import { addCache } from 'api/caching'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
    PaginatedResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import {
    ProductMetadata,
    Report,
    SovKeywordResearch,
    SovKeywordResearchCategories,
} from 'types'

import { BannerRequestBody } from './types'

export const getSovIntradayFactAggregates = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post(
        '/api/sov/search_results/facts/aggregate/banner/',
        params,
        { headers: getCerebroHeaders(options.headers) }
    )
addCache(getSovIntradayFactAggregates)

export const getSovIntradayFactAggregatesExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/sov/search_results/facts/aggregate/banner/export/',
        params
    )

interface KeywordResearchResponse
    extends PaginatedResponse<SovKeywordResearch> {
    top_asins: string[]
    product_metadata: ProductMetadata[]
}

export type KeywordResearchPaginatedResponse =
    AxiosResponse<KeywordResearchResponse>

interface KeywordResearchCategoriesResponse {
    count: number
    results: SovKeywordResearchCategories[]
}

export type KeywordResearchCategoriesPaginatedResponse =
    AxiosResponse<KeywordResearchCategoriesResponse>
